import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ContestHandoverContractDetail } from './contest-handover-contract-details.model';

export interface GenerateContestHandoverContractDetailOptions {
  readonly id?: number;
  readonly entryId?: number;
  readonly usersId?: number;
  readonly fullname?: string;
  readonly phone?: string;
  readonly address?: string;
  readonly country?: string;
  readonly state?: string;
  readonly city?: string;
}

export function generateContestHandoverContractDetailObject({
  id = generateId(),
  entryId = generateId(),
  usersId = generateId(),
  fullname = 'John Doe',
  phone = '1234567890',
  address = '123 Main St',
  country = 'US',
  state = 'CA',
  city = 'Los Angeles',
}: GenerateContestHandoverContractDetailOptions = {}): ContestHandoverContractDetail {
  return {
    id,
    entryId,
    usersId,
    fullname,
    phone,
    address,
    country,
    state,
    city,
  };
}
